import { LayerProps } from "react-map-gl";
import { colors } from "shared/styles/constants";

export const clusterLayer: LayerProps = {
  id: "clusters",
  type: "circle",
  source: "venues",
  filter: ["has", "point_count"],
  paint: {
    "circle-color": colors.grey5,
    "circle-radius": ["step", ["get", "point_count"], 17, 5, 25, 20, 30],
  },
};

export const clusterCountLayer: LayerProps = {
  id: "cluster-count",
  type: "symbol",
  source: "venues",
  filter: ["has", "point_count"],
  layout: {
    "text-field": "{point_count_abbreviated}",
    "text-size": 14,
  },
  paint: {},
};

export const unclusteredPointLayer: LayerProps = {
  id: "unclustered-point",
  type: "symbol",
  source: "venues",
  filter: ["!", ["has", "point_count"]],
  layout: {
    "icon-image": "marker-icon",
    "icon-size": 0.5,
    "icon-offset": [-10, -20],
  },
  paint: {
    "icon-color": colors.red,
  },
};
